import { Column } from 'src/components/tables'
import { hasExtendedAmountDigits, isOcrComparisonHidden } from 'src/domain/org'

export const columns: Column[] = [
  {
    title: '算出項目名称',
    width: 184,
  },
  {
    title: '手入力値',
    width: 148,
  },
  {
    title: 'OCR値',
    width: 148,
  },
  {
    title: '確定値',
    width: 148,
  },
]

export const columnsWithSum: Column[] = [
  {
    title: '算出項目名称',
    width: 160,
  },
  {
    title: '手入力値',
    width: 120,
  },
  {
    title: 'OCR値',
    width: 120,
  },
  {
    title: '確定値',
    width: 120,
  },
  {
    title: '合算値',
    width: 120,
  },
]

// 複数レジでは合算値列を加え、OCR比較を表示しない org ではOCR値列を除外する
export const getColumns = (
  registerCount: number,
  orgCode: string
): Column[] => {
  const base = registerCount === 1 ? columns : columnsWithSum
  return isOcrComparisonHidden(orgCode)
    ? base.filter((column) => column.title !== 'OCR値')
    : base
}

// 金額の桁数と上限値（通常: 9桁 / 三井系: 11桁）
// 上限値は桁数から導出し、両者が乖離しないようにする
const NORMAL_DIGIT_COUNT = 9
const EXTENDED_DIGIT_COUNT = 11
// NOTE: 10 ** n - 0.01 は浮動小数点だが 999999999.99 / 99999999999.99 と厳密に一致する（constants.test.ts で保証）
const NORMAL_LIMIT_VALUE = 10 ** NORMAL_DIGIT_COUNT - 0.01 // = 999999999.99（9桁上限）
const EXTENDED_LIMIT_VALUE = 10 ** EXTENDED_DIGIT_COUNT - 0.01 // = 99999999999.99（11桁上限）

// org に応じた金額の上限値を返す
export const getAmountLimitValue = (orgCode: string): number =>
  hasExtendedAmountDigits(orgCode) ? EXTENDED_LIMIT_VALUE : NORMAL_LIMIT_VALUE

// org に応じた桁数超過エラーメッセージを返す
export const getDigitLimitErrorMessage = (orgCode: string): string =>
  `${hasExtendedAmountDigits(orgCode) ? EXTENDED_DIGIT_COUNT : NORMAL_DIGIT_COUNT}桁以下で入力してください`
